import type { DashboardConfig } from '#types/config/components/dashboard'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    cta: 'w-full',
    header: 'subtitle-4 pb-4 pt-2'
  }
} satisfies RecursivePartial<DashboardConfig['card']>
